// extracted by mini-css-extract-plugin
export var arrowCircleIcon = "cCn6m";
export var bleedthroughColumnHeader = "JJmDx";
export var columnHeader = "h2KSz";
export var columnHeaderCompact = "aspKN";
export var columnHeaderCompactTypeRampUpdates = "Q_Rqr";
export var columnHeaderContainer = "gFfsl";
export var columnHeaderCozy = "s6Xyn";
export var columnHeaderCozyTypeRampUpdates = "Is6Mg";
export var columnHeaderRoomy = "DDtA5";
export var columnHeaderRoomyTypeRampUpdates = "zhgSn";
export var columnHeaderTypeRamp = "A0FS0";
export var columnHeaderTypeRampColorUpdate = "M3R0P";
export var columnHeadersContainer = "s8wta";
export var columnHeadersContainerDenseless = "F24Ks";
export var columnHeadersContainerDenselessBlur = "FWXm5";
export var receivedColumnContainer = "kucbQ";
export var resizeHandle = "RfETL";
export var senderColumnButtonMarginFull = "zwg55";
export var senderColumnButtonMarginMediumCompact = "wMOza";
export var senderColumnNoCheckBoxPaddingLeft = "ObuYn";
export var senderImageOn = "YSRyE";
export var sortIconCompactOrCozy = "eyzjV";
export var sortIconRoomy = "o_YSF";
export var sortedColumnHeaderTitle = "YO6HH";
export var sortingEnabled = "aLhjV";